import React, { useCallback, useEffect, useState } from "react";
import styles from "./EditProfile.module.css";
import profile_picture from "assets/images/profile-pic.svg";
import { useDropzone } from "react-dropzone";
import { AiOutlineUpload } from "react-icons/ai";
import { CircularProgress } from "@mui/material";

import AppBackdrop from "component/appBackdrop/AppBackdrop";
import AuthModalLayout from "component/authModalLayout/AuthModalLayout";
import { useUpdateProfilePic } from "api/mutations/profile";
import AppButton from "component/button/AppButton";
import ValidationMessage from "component/validationMessage/ValidationMessage";

const ProfilePhoto = ({ profileDetails }) => {
  const [image, setImage] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageError, setImageError] = useState("");

  const onDrop = useCallback((acceptedFiles) => {
    setImageError("");
    const file = acceptedFiles[0];
    if (!!file && file.type.substring(0, 5) === "image") {
      setImage(file);
    } else {
      setImageError("Only images are allowed");
      setImage(null);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
  });

  useEffect(() => {
    if (!!image) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onloadend = (e) => {
        setSelectedImage(e.target.result);
      };
    }
  }, [image]);

  const { isLoading, mutate, setOpenModal, openModal } = useUpdateProfilePic();

  const handleUpload = () => {
    const formData = new FormData();
    formData.append("file", image);

    // @ts-ignore
    mutate(formData);
  };

  return (
    <div style={{ width: "fit-content" }}>
      <div className={styles.profile_pic} {...getRootProps()}>
        <img
          src={selectedImage || profileDetails?.avatar || profile_picture}
          alt=""
        />

        {!image && <AppButton btnText={"Edit"} fullwidth height="30px" />}
        {imageError && <ValidationMessage message={imageError} />}
        <input {...getInputProps()} accept="image/*" />
      </div>
      {image && (
        <p className={styles.upload} onClick={handleUpload}>
          Upload
          {isLoading ? (
            <CircularProgress
              size="16px"
              sx={{
                color: "#0072ce",
              }}
            />
          ) : (
            <AiOutlineUpload fontSize="20px" />
          )}
        </p>
      )}

      <AppBackdrop
        openModal={openModal}
        handleCloseModal={() => {}}
        children={
          <AuthModalLayout
            handleClose={() => {
              setOpenModal(false);
            }}
            icon={"success"}
            primaryText="Success"
            secondaryText="Your profile photo has been updated"
          />
        }
      />
    </div>
  );
};

export default ProfilePhoto;
